import { render, staticRenderFns } from "./TableSPTG.vue?vue&type=template&id=3cc8a59e&scoped=true"
import script from "./TableSPTG.vue?vue&type=script&lang=js"
export * from "./TableSPTG.vue?vue&type=script&lang=js"
import style0 from "./TableSPTG.vue?vue&type=style&index=0&id=3cc8a59e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc8a59e",
  null
  
)

export default component.exports